import React, { useContext, useEffect, useState } from 'react';
import s from './styles.module.scss';
import { useRouter } from 'next/router';
import { ROUTE_PATH } from '@/constants/route-path';
import { CDN_URL_ICONS } from '@/configs';
import cs from 'classnames';
import { detectClientOs } from '@/utils/client';
import { ClientOs } from '@/enums/client';
import useAnalyticsEventTracker, { AlphaActions } from '@/utils/ga';
import { useSelector } from 'react-redux';
import { getUnreadCount } from '@/state/notification/selector';
import { useDM } from '@/modules/AlphaPWA/DirectMessage/provider';
import { ALPHA_LAYOUT_NAVBAR_ID } from '@/layouts/AlphaLayout/constants';
import { useAppDispatch } from '@/state/hooks';
import { resetUnreadNotification } from '@/state/notification/reducer';
import { compareString } from '@/utils';
import IconAirdrop from '@/layouts/AlphaLayout/Header/svg/IconAirdrop';
import IconAirDropActive from '@/layouts/AlphaLayout/Header/svg/IconAirDropActive';
import { TradeKeyContext } from '@/contexts/trade-key-context';
import CircleIcon from '@/layouts/AlphaLayout/Header/svg/CircleIcon';
import CircleActiveIcon from '@/layouts/AlphaLayout/Header/svg/CircleActiveIcon';

const CHAT_LABEL = 'Circles';

const NAV_DATA = [
  {
    label: 'Activities',
    iconUrl: `${CDN_URL_ICONS}/ic-alpha-home`,
    svg: (): React.ReactElement => {
      return (
        <svg
          width="29"
          height="28"
          viewBox="0 0 29 28"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M19.3135 7.90101C19.1984 7.76 19.0964 7.63356 19.0104 7.52217C18.9582 7.45415 18.8885 7.40168 18.8087 7.37043C18.7289 7.33918 18.6421 7.33033 18.5576 7.34485C18.4732 7.35937 18.3943 7.3967 18.3295 7.45281C18.2648 7.50891 18.2166 7.58166 18.1902 7.66318C17.9315 8.45304 17.538 9.19218 17.0273 9.84787C17.0574 7.98091 16.6875 4.68649 13.9819 2.91213C13.9109 2.86548 13.8286 2.83896 13.7437 2.83538C13.6588 2.8318 13.5745 2.8513 13.4998 2.8918C13.4251 2.93231 13.3628 2.9923 13.3195 3.06541C13.2762 3.13851 13.2535 3.22199 13.2539 3.30696C13.2539 4.84677 12.429 6.48764 10.9949 7.80747C9.60735 9.08501 6.38339 12.4612 6.41676 16.2012C6.44026 18.8052 7.76623 22.4056 11.1298 23.835C11.1801 22.2007 11.8931 21.0402 12.5906 19.9215C13.2534 18.8574 13.8799 17.8534 13.9373 16.4485C13.9409 16.3584 13.9703 16.2712 14.0221 16.1973C14.0739 16.1235 14.1458 16.0661 14.2293 16.032C14.3128 15.9979 14.4043 15.9886 14.493 16.0051C14.5816 16.0216 14.6637 16.0632 14.7293 16.1251C16.6249 17.9112 17.6407 20.5575 17.6905 23.7865C20.1032 22.7577 22.0792 20.5152 22.3706 16.8673C22.7471 12.1299 20.428 9.27349 19.3135 7.90101Z"
            fill="white"
          />
        </svg>
      );
    },
    url: ROUTE_PATH.ALPHA_MOBILE_HOME,
    visible: true,
  },
  {
    label: CHAT_LABEL,
    iconUrl: `${CDN_URL_ICONS}/direct-message-icon`,
    svg: (): React.ReactElement => {
      return <CircleIcon />;
    },
    svgActive: (): React.ReactElement => {
      return <CircleActiveIcon />;
    },
    url: ROUTE_PATH.ALPHA_MOBILE_DM,
    visible: true,
  },
  // {
  //   label: 'Home',
  //   iconUrl: `${CDN_URL_ICONS}/ic-alpha-home`,
  //   svg: (): React.ReactElement => {
  //     return (
  //       <>
  //         <svg
  //           width="29"
  //           height="28"
  //           viewBox="0 0 29 28"
  //           fill="none"
  //           xmlns="http://www.w3.org/2000/svg"
  //         >
  //           <path
  //             d="M24.3435 13.1875C24.1944 13.1876 24.0497 13.1369 23.9333 13.0438L14.4999 5.49646L5.06657 13.0438C4.99927 13.0977 4.92201 13.1377 4.83922 13.1618C4.75643 13.1858 4.66972 13.1932 4.58404 13.1837C4.49836 13.1742 4.41539 13.1479 4.33988 13.1064C4.26436 13.0648 4.19777 13.0087 4.14391 12.9414C4.09005 12.8741 4.04997 12.7969 4.02596 12.7141C4.00196 12.6313 3.9945 12.5446 4.004 12.4589C4.01351 12.3732 4.0398 12.2903 4.08137 12.2147C4.12294 12.1392 4.17898 12.0726 4.24628 12.0188L14.0898 4.14396C14.2062 4.05077 14.3508 4 14.4999 4C14.649 4 14.7937 4.05077 14.9101 4.14396L24.7536 12.0188C24.8598 12.1037 24.937 12.2196 24.9746 12.3503C25.0121 12.4811 25.008 12.6202 24.963 12.7486C24.9179 12.8769 24.8341 12.9881 24.7231 13.0668C24.6122 13.1454 24.4795 13.1876 24.3435 13.1875Z"
  //             fill="white"
  //           />
  //           <path
  //             d="M14.4998 7.17773L6.625 13.4776V23.031C6.625 23.2051 6.69414 23.372 6.81721 23.4951C6.94027 23.6181 7.10719 23.6873 7.28123 23.6873H21.7184C21.8924 23.6873 22.0594 23.6181 22.1824 23.4951C22.3055 23.372 22.3746 23.2051 22.3746 23.031V13.4776L14.4998 7.17773Z"
  //             fill="white"
  //           />
  //         </svg>
  //       </>
  //     );
  //   },
  //   url: ROUTE_PATH.ALPHA_MOBILE_HOME,
  //   visible: true,
  // },

  {
    label: 'Keys',
    iconUrl: `${CDN_URL_ICONS}/ic-alpha-key3`,
    url: ROUTE_PATH.ALPHA_MOBILE_KEYS,
    svg: (): React.ReactElement => {
      return (
        <svg
          width="29"
          height="28"
          viewBox="0 0 29 28"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M16.8498 10.7308L10.1179 17.4613L7.76344 15.1069L6.81061 16.0583L9.17058 18.4142L8.84745 18.7373L6.49162 16.3815L6.09944 16.775C6.19011 16.8657 6.26203 16.9733 6.31111 17.0918C6.36018 17.2103 6.38544 17.3373 6.38544 17.4655C6.38544 17.5937 6.36018 17.7207 6.31111 17.8392C6.26203 17.9576 6.19011 18.0653 6.09944 18.1559C6.00877 18.2466 5.90113 18.3185 5.78266 18.3676C5.66419 18.4167 5.53722 18.4419 5.40899 18.4419C5.28076 18.4419 5.15378 18.4167 5.03532 18.3676C4.91685 18.3185 4.80921 18.2466 4.71853 18.1559L4.3374 18.5371L6.68495 20.8929L5.96964 21.6082C5.92145 21.6562 5.88322 21.7132 5.85713 21.776C5.83105 21.8388 5.81762 21.9062 5.81762 21.9742C5.81762 22.0422 5.83105 22.1095 5.85713 22.1723C5.88322 22.2351 5.92145 22.2921 5.96964 22.3401L6.406 22.7765C6.45399 22.8246 6.51101 22.8629 6.57381 22.889C6.63661 22.9151 6.70394 22.9285 6.77194 22.9285C6.83995 22.9285 6.90727 22.9151 6.97007 22.889C7.03287 22.8629 7.0899 22.8246 7.13789 22.7765L18.0153 11.899L18.3799 12.265L18.703 11.9419C18.8641 12.3432 19.1042 12.7081 19.4089 13.015C19.7137 13.3219 20.077 13.5644 20.4772 13.7283C20.8774 13.8922 21.3065 13.9741 21.7389 13.9691C22.1714 13.9641 22.5985 13.8724 22.9948 13.6993C23.3912 13.5262 23.7487 13.2754 24.0463 12.9616C24.3439 12.6477 24.5755 12.2774 24.7274 11.8724C24.8792 11.4675 24.9482 11.0361 24.9302 10.604C24.9123 10.1719 24.8078 9.74778 24.623 9.35679C25.1474 8.63082 25.3964 7.74197 25.3256 6.84921C25.2547 5.95645 24.8686 5.11801 24.2363 4.48383C23.6039 3.84966 22.7666 3.46112 21.874 3.3877C20.9815 3.31429 20.0919 3.56078 19.3644 4.0831C18.9733 3.88883 18.5469 3.77582 18.1109 3.7509C17.6749 3.72597 17.2384 3.78965 16.8276 3.93808C16.4169 4.08651 16.0405 4.31662 15.7212 4.61453C15.4019 4.91243 15.1462 5.27194 14.9697 5.67138C14.7931 6.07081 14.6993 6.50187 14.6939 6.93855C14.6886 7.37523 14.7717 7.80847 14.9384 8.21213C15.1051 8.61578 15.3518 8.98148 15.6637 9.28716C15.9756 9.59283 16.3462 9.83213 16.7531 9.99063L16.43 10.3138L16.8498 10.7308ZM19.4238 8.46334L19.3962 8.49234C19.3769 8.51167 19.3562 8.52962 19.3354 8.54758C19.0526 8.09352 18.9144 7.56426 18.939 7.02988C18.9637 6.49551 19.1501 5.98123 19.4735 5.55515C19.8405 5.94626 20.0433 6.46338 20.04 6.99971C20.0366 7.53603 19.8274 8.05059 19.4556 8.4371L19.4238 8.46334ZM20.2317 9.27117C20.2413 9.26289 20.2496 9.25184 20.2579 9.24356C20.6476 8.86887 21.1672 8.65959 21.7078 8.65959C22.2485 8.65959 22.7681 8.86887 23.1578 9.24356C22.7276 9.56972 22.2077 9.75622 21.6682 9.77795C21.1288 9.79967 20.5956 9.65558 20.1405 9.36508C20.1599 9.34298 20.1792 9.3195 20.1999 9.29879L20.2317 9.27117ZM18.4889 4.96688C18.0712 5.55797 17.8319 6.25651 17.7994 6.97957C17.7668 7.70263 17.9424 8.41984 18.3053 9.04609C17.9966 9.10066 17.6795 9.08515 17.3776 9.00071C17.0757 8.91626 16.7966 8.76504 16.561 8.55822C16.3254 8.3514 16.1392 8.09427 16.0164 7.80584C15.8935 7.51741 15.837 7.20504 15.8511 6.89185C15.8652 6.57866 15.9496 6.27264 16.0978 5.99641C16.2461 5.72019 16.4546 5.48082 16.7079 5.29601C16.9611 5.1112 17.2527 4.98567 17.5609 4.9287C17.8692 4.87173 18.1864 4.88478 18.4889 4.96688ZM23.8993 8.3722C23.5303 8.03245 23.0873 7.78332 22.6053 7.64454C22.1232 7.50576 21.6155 7.48114 21.1223 7.57265C21.214 7.08331 21.1913 6.5794 21.056 6.10029C20.9206 5.62118 20.6763 5.17986 20.3421 4.81084C20.8395 4.5502 21.4071 4.45526 21.9621 4.53985C22.5172 4.62445 23.0308 4.88417 23.4279 5.28112C23.825 5.67808 24.0849 6.19152 24.1697 6.74657C24.2545 7.30161 24.1598 7.86924 23.8993 8.36668V8.3722ZM20.2289 12.2291C19.9929 11.9924 19.8171 11.7027 19.7162 11.3841C19.6153 11.0655 19.5922 10.7273 19.6489 10.398C20.2743 10.7649 20.992 10.9442 21.7165 10.9146C22.441 10.8849 23.1417 10.6476 23.735 10.2309C23.8486 10.6751 23.813 11.1443 23.6338 11.5662C23.4546 11.9882 23.1416 12.3396 22.7431 12.5662C22.3446 12.7928 21.8826 12.8822 21.4283 12.8206C20.974 12.7589 20.5526 12.5496 20.2289 12.2249V12.2291Z"
            fill="white"
          />
        </svg>
      );
    },
    visible: true,
  },
  {
    label: 'Placeholders',
    iconUrl: `${CDN_URL_ICONS}/ic_place_holder`,
    url: ROUTE_PATH.ALPHA_MOBILE_PLACE_HOLDER_KEYS,
    svg: (): React.ReactElement => {
      return (
        <>
          <svg
            width="28"
            height="28"
            viewBox="0 0 28 28"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M22.1071 24.4886H5.89859C5.77216 24.4886 5.65091 24.4384 5.5615 24.349C5.4721 24.2596 5.42188 24.1383 5.42188 24.0119V22.105C5.42188 21.7257 5.57255 21.3619 5.84076 21.0937C6.10897 20.8255 6.47273 20.6748 6.85203 20.6748H21.1536C21.5329 20.6748 21.8967 20.8255 22.1649 21.0937C22.4331 21.3619 22.5838 21.7257 22.5838 22.105V24.0119C22.5838 24.1383 22.5336 24.2596 22.4442 24.349C22.3548 24.4384 22.2335 24.4886 22.1071 24.4886Z"
              fill="white"
            />
            <path
              d="M22.5836 7.32677C22.2374 7.32697 21.8979 7.42138 21.6013 7.59988C21.3047 7.77837 21.0624 8.03422 20.9001 8.33999C20.7379 8.64576 20.662 8.98992 20.6805 9.33556C20.699 9.68121 20.8112 10.0153 21.0051 10.302L17.0808 13.6629L14.7839 7.15515C15.182 6.97636 15.5066 6.66647 15.7038 6.27719C15.9009 5.88791 15.9586 5.4428 15.8672 5.01614C15.7757 4.58948 15.5407 4.20708 15.2014 3.93276C14.8621 3.65844 14.4389 3.50879 14.0026 3.50879C13.5663 3.50879 13.1431 3.65844 12.8038 3.93276C12.4645 4.20708 12.2295 4.58948 12.138 5.01614C12.0466 5.4428 12.1043 5.88791 12.3014 6.27719C12.4986 6.66647 12.8232 6.97636 13.2213 7.15515L10.9244 13.6629L7.00006 10.302C7.23852 9.94945 7.35217 9.52726 7.32292 9.10264C7.29368 8.67802 7.12321 8.27539 6.83868 7.95886C6.55414 7.64233 6.17188 7.43009 5.75277 7.35594C5.33366 7.28178 4.90179 7.34998 4.52592 7.54967C4.15005 7.74935 3.85179 8.06905 3.67862 8.45786C3.50546 8.84666 3.46735 9.28223 3.57037 9.6952C3.67338 10.1082 3.91159 10.4748 4.24707 10.7367C4.58256 10.9987 4.99603 11.1408 5.42165 11.1406C5.53366 11.1392 5.64533 11.1278 5.75535 11.1067L7.80524 17.8848V19.7216H20.2V17.8848L22.2498 11.1067C22.5116 11.1566 22.781 11.1511 23.0405 11.0904C23.3 11.0298 23.544 10.9155 23.7566 10.7548C23.9692 10.5941 24.1458 10.3906 24.2749 10.1575C24.404 9.92432 24.4828 9.6667 24.5063 9.40122C24.5297 9.13574 24.4972 8.8683 24.411 8.61614C24.3247 8.36399 24.1865 8.13272 24.0053 7.93726C23.8242 7.74179 23.604 7.58648 23.3591 7.48132C23.1143 7.37617 22.85 7.32352 22.5836 7.32677Z"
              fill="white"
            />
          </svg>
        </>
      );
    },
    visible: true,
  },
  {
    label: '(3,3)',
    iconUrl: `${CDN_URL_ICONS}/ic-alpha-airdrop1`,
    url: `${ROUTE_PATH.ALPHA_MOBILE_KEYS_INVITATIONS}?pageHistory=1`,
    router: ROUTE_PATH.ALPHA_MOBILE_KEYS_INVITATIONS,
    svg: (): React.ReactElement => {
      return (
        <>
          <svg
            width="29"
            height="28"
            viewBox="0 0 29 28"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M22.0751 5.46891H6.32531C5.97955 5.46513 5.63651 5.53044 5.31633 5.66102C4.99615 5.79159 4.70527 5.9848 4.46076 6.2293C4.21626 6.47381 4.02305 6.76468 3.89247 7.08485C3.76189 7.40503 3.69657 7.74806 3.70035 8.09382V19.9059C3.69657 20.2517 3.76189 20.5947 3.89247 20.9149C4.02305 21.2351 4.21626 21.5259 4.46076 21.7704C4.70527 22.0149 4.99615 22.2081 5.31633 22.3387C5.63651 22.4693 5.97955 22.5346 6.32531 22.5308H22.0751C22.4208 22.5346 22.7639 22.4693 23.0841 22.3387C23.4042 22.2081 23.6951 22.0149 23.9396 21.7704C24.1841 21.5259 24.3773 21.2351 24.5079 20.9149C24.6385 20.5947 24.7038 20.2517 24.7 19.9059V8.09382C24.7038 7.74806 24.6385 7.40503 24.5079 7.08485C24.3773 6.76468 24.1841 6.47381 23.9396 6.2293C23.6951 5.9848 23.4042 5.79159 23.0841 5.66102C22.7639 5.53044 22.4208 5.46513 22.0751 5.46891ZM22.4688 9.93126L14.5939 15.8373C14.4803 15.9225 14.3422 15.9686 14.2002 15.9686C14.0582 15.9686 13.92 15.9225 13.8065 15.8373L5.93157 9.93126C5.79233 9.82683 5.70028 9.67137 5.67567 9.49908C5.65105 9.32678 5.69589 9.15177 5.80032 9.01254C5.90475 8.8733 6.06021 8.78125 6.23251 8.75664C6.4048 8.73203 6.57982 8.77687 6.71906 8.88129L14.2002 14.492L21.6813 8.88129C21.7503 8.82958 21.8287 8.79196 21.9122 8.77058C21.9957 8.74919 22.0826 8.74445 22.1679 8.75664C22.2532 8.76883 22.3353 8.7977 22.4094 8.84161C22.4836 8.88551 22.5484 8.94359 22.6001 9.01254C22.6518 9.08148 22.6894 9.15993 22.7108 9.24341C22.7322 9.32689 22.7369 9.41377 22.7247 9.49908C22.7125 9.58439 22.6837 9.66646 22.6398 9.74062C22.5958 9.81477 22.5378 9.87955 22.4688 9.93126Z"
              fill="white"
            />
          </svg>
        </>
      );
    },
    visible: true,
  },
  // {
  //   label: 'Activities',
  //   iconUrl: `${CDN_URL_ICONS}/ic-alpha-noti1`,
  //   url: ROUTE_PATH.ALPHA_MOBILE_NOTI,
  //   svg: (): React.ReactElement => {
  //     return (
  //       <svg
  //         width="29"
  //         height="28"
  //         viewBox="0 0 29 28"
  //         fill="none"
  //         xmlns="http://www.w3.org/2000/svg"
  //       >
  //         <path
  //           d="M19.3135 7.90101C19.1984 7.76 19.0964 7.63356 19.0104 7.52217C18.9582 7.45415 18.8885 7.40168 18.8087 7.37043C18.7289 7.33918 18.6421 7.33033 18.5576 7.34485C18.4732 7.35937 18.3943 7.3967 18.3295 7.45281C18.2648 7.50891 18.2166 7.58166 18.1902 7.66318C17.9315 8.45304 17.538 9.19218 17.0273 9.84787C17.0574 7.98091 16.6875 4.68649 13.9819 2.91213C13.9109 2.86548 13.8286 2.83896 13.7437 2.83538C13.6588 2.8318 13.5745 2.8513 13.4998 2.8918C13.4251 2.93231 13.3628 2.9923 13.3195 3.06541C13.2762 3.13851 13.2535 3.22199 13.2539 3.30696C13.2539 4.84677 12.429 6.48764 10.9949 7.80747C9.60735 9.08501 6.38339 12.4612 6.41676 16.2012C6.44026 18.8052 7.76623 22.4056 11.1298 23.835C11.1801 22.2007 11.8931 21.0402 12.5906 19.9215C13.2534 18.8574 13.8799 17.8534 13.9373 16.4485C13.9409 16.3584 13.9703 16.2712 14.0221 16.1973C14.0739 16.1235 14.1458 16.0661 14.2293 16.032C14.3128 15.9979 14.4043 15.9886 14.493 16.0051C14.5816 16.0216 14.6637 16.0632 14.7293 16.1251C16.6249 17.9112 17.6407 20.5575 17.6905 23.7865C20.1032 22.7577 22.0792 20.5152 22.3706 16.8673C22.7471 12.1299 20.428 9.27349 19.3135 7.90101Z"
  //           fill="white"
  //         />
  //       </svg>
  //     );
  //   },
  //   visible: false,
  // },
  {
    label: 'Airdrop',
    iconUrl: `${CDN_URL_ICONS}/ic-alpha-airdrop1`,
    url: ROUTE_PATH.ALPHA_MOBILE_MINE,
    svg: (): React.ReactElement => {
      return <IconAirdrop />;
    },
    svgActive: (): React.ReactElement => {
      return <IconAirDropActive />;
    },
    visible: true,
  },
  {
    label: 'Games',
    iconUrl: `${CDN_URL_ICONS}/alpha-game-icon`,
    url: ROUTE_PATH.ALPHA_MOBILE_GAMES,
    visible: false,
    svg: (): React.ReactElement => {
      return (
        <>
          <svg
            width="29"
            height="28"
            viewBox="0 0 29 28"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M9.49963 12.0732V14.8736"
              stroke="white"
              strokeLinecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M8.09949 13.4736H10.8998"
              stroke="white"
              strokeLinecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M20.0009 11.373H18.6007V12.7732H20.0009V11.373Z"
              fill="white"
            />
            <path
              d="M18.6007 14.1738H17.2006V15.574H18.6007V14.1738Z"
              fill="white"
            />
            <path
              d="M21.401 14.1738H20.0009V15.574H21.401V14.1738Z"
              fill="white"
            />
            <path
              d="M24.8662 20.1662L23.501 11.3731C23.5019 10.505 23.1802 9.66759 22.5984 9.02337C22.0165 8.37916 21.2161 7.97411 20.3524 7.88687C19.4888 7.79963 18.6235 8.03642 17.9246 8.55127C17.2257 9.06612 16.743 9.8223 16.5703 10.673H12.2298C12.057 9.8223 11.5744 9.06612 10.8755 8.55127C10.1766 8.03642 9.31128 7.79963 8.44761 7.88687C7.58394 7.97411 6.7835 8.37916 6.20167 9.02337C5.61984 9.66759 5.29813 10.505 5.29901 11.3731L3.93385 20.1662C3.87446 20.4315 3.89357 20.7083 3.98887 20.9629C4.08417 21.2175 4.25153 21.4389 4.47052 21.6C4.68952 21.7611 4.95067 21.8549 5.2221 21.8701C5.49354 21.8852 5.76352 21.8211 5.99908 21.6854L12.2998 17.6739H16.5003L22.801 21.6854C23.0365 21.8211 23.3065 21.8852 23.5779 21.8701C23.8494 21.8549 24.1105 21.7611 24.3295 21.6C24.5485 21.4389 24.7159 21.2175 24.8112 20.9629C24.9065 20.7083 24.9256 20.4315 24.8662 20.1662Z"
              stroke="white"
              strokeLinecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </>
      );
    },
    svgActive: (): React.ReactElement => {
      return (
        <>
          <svg
            width="29"
            height="28"
            viewBox="0 0 29 28"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M24.9133 18.219L23.2117 9.71084C22.819 7.87832 21.1174 6.43848 19.154 6.43848C16.7979 6.43848 15.358 8.66368 15.0962 9.05637H13.7873C13.5255 8.66368 12.0857 6.43848 9.72959 6.43848C7.76618 6.43848 6.06456 7.87832 5.67187 9.71084L3.97025 18.219C3.83936 19.1352 4.10115 20.0515 4.88651 20.4442C5.67188 20.9678 6.58813 20.8369 7.3735 20.3133L12.2166 16.91H16.5361L21.3792 20.4442C22.1645 20.9678 22.9499 21.0987 23.8662 20.5751C24.6515 20.0515 25.0442 19.1352 24.9133 18.219ZM11.8239 12.9832H10.515V14.2921H9.20602V12.9832H7.89707V11.6743H9.20602V10.3653H10.515V11.6743H11.8239V12.9832ZM18.3686 14.2921H17.0597V12.9832H18.3686V14.2921ZM18.3686 10.3653H19.6775V11.6743H18.3686V10.3653ZM20.9865 14.2921H19.6775V12.9832H20.9865V14.2921Z"
              fill="white"
            />
          </svg>
        </>
      );
    },
  },
];

const NavBar: React.FC = (): React.ReactElement => {
  const router = useRouter();
  const { getUnreadMessages } = useDM();
  const clientOs = detectClientOs();
  const gaEventTracker = useAnalyticsEventTracker();
  const unreadCount = useSelector(getUnreadCount);
  const [unreadChat, setUnreadChat] = useState(0);
  const dispatch = useAppDispatch();
  const { has33Requested } = useContext(TradeKeyContext);

  useEffect(() => {
    setUnreadChat(getUnreadMessages());
  }, [getUnreadMessages]);

  const isRouteActive = (route: string) => {
    return router.pathname === route;
  };

  const gotoLink = (url: string) => {
    gaEventTracker(AlphaActions.ClickTab, url);
    router.push(url);
    if (compareString(url, ROUTE_PATH.ALPHA_MOBILE_NOTI)) {
      dispatch(resetUnreadNotification());
    }
  };

  return (
    <nav
      id={ALPHA_LAYOUT_NAVBAR_ID}
      className={cs(s.navbar, {
        [`${s.ios}`]: clientOs === ClientOs.Ios,
      })}
    >
      <ul className={s.list}>
        {NAV_DATA.map((item) => {
          const isActive = isRouteActive(item.router || item.url);
          return item.visible ? (
            <li
              key={item.url}
              className={cs(s.item, {
                [`${s.active}`]: isActive,
                // [`${s.filledSvg}`]: item.label !== 'Airdrop',
              })}
              onClick={() => gotoLink(item.url)}
              onTouchEnd={() => gotoLink(item.url)}
            >
              <div className={`${isActive ? s.isActive : ''} ${s.iconWrapper}`}>
                {item.label === CHAT_LABEL && !isActive && !!unreadChat && (
                  <span className={s.redDot}>
                    {unreadChat < 10 ? unreadChat : '9+'}
                  </span>
                )}
                {/*{item.label === 'Activities' && unreadCount > 0 && (*/}
                {/*  <span className={`${s.redDot} ${s.redDot__small}`}>*/}
                {/*    /!* {unreadCount < 10 ? unreadCount : '9+'} *!/*/}
                {/*  </span>*/}
                {/*)}*/}
                {item.label === '(3,3)' && has33Requested && (
                  <span className={`${s.redDot} ${s.redDot__small}`}></span>
                )}
                {item.svg()}
              </div>
              <span>{item.label}</span>
            </li>
          ) : (
            <></>
          );
        })}
      </ul>
    </nav>
  );
};

export default NavBar;
